import Logout from '@mui/icons-material/Logout'
import { CircularProgress, Dropdown } from '@mui/joy'
import { useStore } from 'effector-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { viewerModel } from '~/entities/viewer'
import { UserIcon } from '~/shared/ui/Icons'
import { MenuButton, Menu, MenuItem } from './styled'

export function AccountMenu() {
  const { t } = useTranslation()
  const isLogoutPending = useStore(viewerModel.logoutFx.pending)

  return (
    <Dropdown>
      <MenuButton
        loading={isLogoutPending}
        disabled={isLogoutPending}
        loadingIndicator={<CircularProgress />}
      >
        <UserIcon />
      </MenuButton>
      <Menu>
        <MenuItem component={Link} to='/user-personal-data'>
          {t('personal data')}
        </MenuItem>
        <MenuItem onClick={() => viewerModel.signOut()}>
          <Logout />
          {t('logout')}
        </MenuItem>
      </Menu>
    </Dropdown>
  )
}
